import React, { memo, useMemo } from 'react';
import { Progress, Typography } from '../../../../../../../components';
import { getGiBfromMiBOneDecimal, getStatusBarColor } from '../../../../../../../lib/helpers';
import { getCriteriaIcon } from './CriteriaIcons';

import './StorageAndMemoryCriteria.scss';

const { Text } = Typography;

export const MemoryCriteria = memo(({ criteria, total, used }) => {
    const usedValue = getGiBfromMiBOneDecimal(used);
    const totalValue = getGiBfromMiBOneDecimal(total);
    const percent = useMemo(() => {
        return totalValue ? (usedValue / totalValue) * 100 : 0;
    }, [usedValue, totalValue]);

    return (
        <div className="storage-and-memory-criteria">
            <div className="label-row">
                <Text className="progress-bar-label">
                    Memory
                    {getCriteriaIcon(criteria)}
                </Text>
                <Text className="semi-bold memory-progress-value">
                    Used: {total === 0 ? 'N/A' : `${usedValue} GiB`} / {totalValue} GiB
                </Text>
            </div>
            <Progress
                percent={percent}
                showInfo={false}
                strokeColor={getStatusBarColor(criteria)}
                format={() => `${usedValue} / ${totalValue}`}
            />
        </div>
    );
});
